/** Same rule as sidebar `canAccessBulkMenu` and bulk-upload-module access gate. */
export function canAccessBulkUpload(roleName: string): boolean {
  const n = roleName.trim().toLowerCase();
  return n === 'super admin' || n === 'superadmin' || n === 'administrator';
}

export function isTruthyRoleFlag(value: any): boolean {
  if (value === true || value === 1) return true;
  if (typeof value === 'string') {
    const v = value.trim().toLowerCase();
    return v === 'true' || v === '1';
  }
  return false;
}

/** Same roles as bulk upload: Super Admin and Administrator. */
export function canAccessBulkUpdate(roleName: string): boolean {
  return canAccessBulkUpload(roleName);
}

/** Resolve role name from PULSE session storage (matches app.component logic). */
export function resolvePulseRoleName(): string {
  try {
    const raw = localStorage.getItem('current_user');
    if (raw) {
      const parsed = JSON.parse(raw);
      const fromUser = String(parsed?.role?.name || '').trim();
      if (fromUser) return fromUser;
    }
  } catch {
    /* ignore */
  }
  try {
    const roleDetail = localStorage.getItem('role_detail');
    if (roleDetail) {
      const parsed = JSON.parse(roleDetail);
      const fromDetail = String(parsed?.name || '').trim();
      if (fromDetail) return fromDetail;
    }
  } catch {
    /* ignore */
  }
  return '';
}
